import React, { useState } from 'react';
import VendorProgramList from '../vendor-program/vendor-program-list';
import * as helper from '../../utils/helper';
import { useMutation, useQuery } from '@apollo/client';
import FETCH_VENDOR_PROGRAMS from '../../queries/fetch-vendor-programs.graphql';
import UPDATE_VENDOR_PROGRAM from '../../mutation/update-vendor-program.graphql';
import DELETE_VENDOR_PROGRAM from '../../mutation/delete-vendor-program.graphql';
import CREATE_VENDOR_PROGRAM from '../../mutation/create-vendor-program.graphql';
import toastr from '../../utils/toastr';
import { useVendorPointSolutionContext } from '../vendor-solution-provider';

const VendorProgramListContainer = props => {
  const { selectedOrgNode } = useVendorPointSolutionContext();
  const [vendorPrograms, setVendorPrograms] = useState([]);
  const { isGroup } = helper.getOrganizationInfo(selectedOrgNode);

  const { loading: showLoading} = useQuery(FETCH_VENDOR_PROGRAMS, {
    fetchPolicy: 'network-only',
    variables: {
      entityId: selectedOrgNode.organization_id
    },
    onCompleted: data => formatVendorPrograms(data.vendorPrograms)
  });

  const formatVendorPrograms = data => {
    const vendorProgramsData = isGroup
      ? data.map(vendorProgram => ({
        ...vendorProgram,
        isInherited: vendorProgram.organizationId !== selectedOrgNode.organization_id.toString()
      }))
      : data;

    setVendorPrograms(vendorProgramsData);
  };

  const [callCreateVendorProgram, { loading: createLoading }] = useMutation(CREATE_VENDOR_PROGRAM, {
    onCompleted: data => handleResponse(data.createVendorProgram, "Created"),
    onError: (e) => handleError(e)
  });

  const [callEditVendorProgram, { loading: editLoading }] = useMutation(UPDATE_VENDOR_PROGRAM, {
    onCompleted: data => handleResponse(data.updateVendorProgram, "Updated"),
    onError: (e) => handleError(e)
  });

  const [callDeleteVendorProgram, { loading: deletingLoading }] = useMutation(DELETE_VENDOR_PROGRAM, {
    onCompleted: data => handleResponse(data.deleteVendorProgram, "Deleted"),
    onError: (e) => handleError(e)
  });

  const handleEditVendorProgram = async (values, vendorProgram) => {
    await callEditVendorProgram({
      variables: {
        vendorProgramId: vendorProgram.vendorProgramId,
        vendorProgramParams: values,
        entityId: selectedOrgNode.organization_id
      }
    });
  };

  const handleDeleteVendorProgram = async vendorProgram => {
    if (deletingLoading) return;

    const isConfirm = window.confirm('Please confirm you want to delete this vendor program?');
    if (isConfirm) {
      await callDeleteVendorProgram({
        variables: {
          vendorProgramId: vendorProgram.vendorProgramId,
          entityId: selectedOrgNode.organization_id
        }
      });
    }
  };

  const handleCreateVendorProgram = async values => {
    await callCreateVendorProgram({
      variables: {
        entityId: selectedOrgNode.organization_id,
        vendorProgramParams: values
      }
    });
  };

  const handleError = (e) => {
    toastr.error('Something went wrong');
    console.log(e);
  }

  const handleResponse = (response, action) => {
    const { success, vendorPrograms, errors } = response;
    if (success) {
      formatVendorPrograms(vendorPrograms)
      toastr.success(`${action} vendor program successfully`);
    } else {
      toastr.error(errors.join("\n"));
    }
  };

  return (
    <VendorProgramList
      vendorPrograms={vendorPrograms}
      showLoading={showLoading}
      onEditVendorProgram={handleEditVendorProgram}
      editLoading={editLoading}
      onDeleteVendorProgram={handleDeleteVendorProgram}
      deleteLoading={deletingLoading}
      onCreateVendorProgram={handleCreateVendorProgram}
      createLoading={createLoading}
      isGroup={isGroup}
      organizationName={selectedOrgNode.organization_nm}
      {...props}
    />
  );
};

export default VendorProgramListContainer;
